// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"603":"d218c735","720":"d218c735"}[chunkId] + ".chunk.css";
};